<template>
  <div class="flex flex-col gap-4">
    <div v-if="orders?.length > 0" class="flex flex-col gap-4">
      <div v-for="(order, index) in orders" :key="index" class="my-account-order-entry">
        <div class="title flex px-4 py-2 cursor-pointer font-bold text-primary-contrast bg-primary text-base justify-between items-center" @click="toggleDetails(index)">
          <div>Bestellung {{ order?.customData?.expOrder?.effiOrderId }} - {{ getDate(order.created) }}</div>
          <div class="font-extrabold">
            <div v-if="!showDetails[index]">+</div>
            <div v-else>-</div>
          </div>
        </div>
        <div v-if="showDetails[index]" class="view text-sm p-4 border">
          <MyAccountOrderEntry :order="order" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="bg-error-light border border-error-dark text-center text-error-dark p-4 text-sm">Es gab keine Bestellungen im {{ date }}.</div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { Order } from '~/composables/shoppingCartApi';
defineProps({
  orders: {
    type: Array<Order>,
    default: () => []
  },
  date: {
    type: String,
    required: true
  }
});

const showDetails: Ref<Record<number, boolean>> = ref({})

const toggleDetails = (index: number) => {
  if (showDetails.value[index] === undefined) {
    showDetails.value[index] = false;
  }
  showDetails.value[index] = !showDetails.value[index];
}

const getDate = (timestamp: number): string => {
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(timestamp));
}
</script>